<template>
  <div class="main">
    <div class="mainer">
      <div class="title">相关阅读</div>
      <ul class="type-ul">
        <li :class="typeCurrent == index ? 'li' : ''" v-for="(item, index) in typeList" :key="index"
            @click="changeType(item, index)">{{ item }}
        </li>
      </ul>
      <div class="s-mess" v-for="(item, index) in list" :key="index">
        <div class="s-content" @click="goDetail(item, index)">
          <div class="c-title">
            <div class="t-l">{{ item.title }}</div>
            <div class="t-r">
              <!-- <img class="person" src="../../../assets/homepage/20.png" alt="" /> -->
              <span class="name">{{ item.author }}</span>
            </div>
          </div>
          <div class="c-content">{{ item.textContent }}</div>
        </div>
      </div>
      <div class="bgc" v-if="list == null || list.length == 0">
        <a-empty style="padding:80px"/>
      </div>
    </div>
    <a-modal :title="relatedReadInfo.title" :visible="relatedVisible" @cancel="relatedVisible = false" :footer="null"
             :destroyOnClose="true" width="1000px" centered>
      <div class="relatedReadInfo-content scroll">
        <h3 class="relatedReadInfo-title">{{ relatedReadInfo.title }}</h3>
        <p class="relatedReadInfo-author">{{ relatedReadInfo.author }}</p>
        <div v-if="curIndex > 0" class="prev" @click="goto(-1)">上一篇</div>
        <div v-if="curIndex < list.length-1" class="next" @click="goto(1)">下一篇</div>
        <!--        <vue-pdf-embed v-for="(item,idx) in relatedReadInfo.fileList" :key="idx"-->
        <!--                       :source="($resBasePath + item.path)" />-->
        <div v-for="(item, index) in relatedReadInfo.info" :key="index">
          <p :style="{ 'text-indent': '2em', 'line-height': '2em', 'text-align': item.align }">
            {{ item.content }}</p>
<!--          <ts-video v-if="item.videoList" ref="myVideo" :videos="item.videoList">-->
<!--          </ts-video>-->
          <ts-video ref="myVideo"  v-if="item.videoList" :videos="item.videoList" :index="0"></ts-video>
<!--          <rich-text-view-->
<!--              :key="new Date().getTime()"-->
<!--              class="videoContent"-->
<!--              :videos="item.videoList||[]"-->
<!--          ></rich-text-view>-->
          <a-carousel v-if="item.imageList" arrows>
            <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;zIndex: 1">
              <a-icon type="left-circle"/>
            </div>
            <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
              <a-icon type="right-circle"/>
            </div>
            <div v-for="img in item.imageList" :key="img.id" style="text-align:center">
              <img style="height:400px;max-width:100%;margin:auto" :src="$resBasePath + img.path"/>
              <p class="title" v-if="img.name">{{ img.name }}</p>
            </div>
          </a-carousel>
          <template v-if="item.audioList">
            <div v-for="audio in item.audioList" style="text-align: center;" :key="audio.id">
              <audio controls :src="$resBasePath + audio.path"></audio>
              <p v-if="audio.name">{{ audio.name }}</p>
            </div>
          </template>
        </div>
      </div>
    </a-modal>
    <a-modal  :visible="imgView" width="1000px" title="" :footer="null" @cancel="imgView = false"
             destroyOnClose  >
      <a-spin :spinning="loading">
        <div class="relatedReadInfo-content scroll">
          <h3 class="relatedReadInfo-title">{{ relatedReadInfo.title }}</h3>
          <p class="relatedReadInfo-author">{{ relatedReadInfo.author }}</p>
          <div v-if="curIndex > 0" class="prev" @click="goto(-1)">上一篇</div>
          <div v-if="curIndex < list.length-1" class="next" @click="goto(1)">下一篇</div>
          <div :style="'padding-top:10px;' + frameHeight">
            <iframe :src="`${previewUrl}onlinePreview?url=${encodeURIComponent(base64Encode(previewFile.url))}`"
                    width="100%" height="100%" @load="onload"></iframe>
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>

import FilePreview from '../../components/FilePreview.vue'
import RichTextView from "../../components/richTextView.vue";
import tsVideo from '@/views/books/components/tsVideos.vue'
// import tsVideo from './components/tsvideo.vue';

export default {
  name: 'relatedReading',
  components: {FilePreview,RichTextView,tsVideo},
  data() {
    return {
      styleId: localStorage.getItem('styleId'),
      access_token: this.$store.state.access_token,
      dataList: [],
      typeList: [],
      list: [],
      detailMess: {},
      relatedReadInfo: {},
      typeCurrent: 0,
      curIndex: 0,
      relatedVisible: false, // 相关阅读
      previewFile: {name: '', url: ''},
      imgView: false,
      loading: true,
      frameHeight: 'height:83vh;',
      previewUrl: this.$previewUrl,
    }
  },
  mounted() {
    this.getDataList()
  },
  methods: {
    goto(idx) {
      const newIdx = this.curIndex + idx
      const item = this.list[newIdx]
      this.goDetail(item, newIdx)
    },
    next(item) {
      const param = {
        styleId: this.styleId,
        id: item.id,
        access_token: this.access_token
      }
      this.$http.post(this.$httpConfig.getRelatedRead, param).then((res) => {
        if (res) {
          this.relatedReadInfo = res
        }
      })
    },
    changeType(item, index) {
      this.typeCurrent = index
      this.list = this.dataList.filter((o) => {
        return item == o.type
      })
      this.list = this.list[0].relatedReads
    },
    getDataList() {
      const param = {
        styleId: this.styleId,
        access_token: this.access_token
      }
      const _this = this

      this.$fetch({
        url: this.$httpConfig.getRelatedRead,
        body: param
      })
          .loading(() => (this.loading = true))
          .done((res) => {
            _this.dataList = res.resultData
            _this.list = res.resultData[0].relatedReads
            res.resultData.map((item) => {
              return _this.typeList.push(item.type)
            })
          })
    },
    goDetail(d, index) {
      this.curIndex = index
      const param = {
        access_token: this.access_token,
        id: d.id
      }

      this.$fetch({
        url: this.$httpConfig.getRelatedReadInfo,
        body: param
      })
          .loading(() => (this.loading = true))
          .done((res) => {
            this.relatedReadInfo = res.resultData
            const infos = this.relatedReadInfo?.info.map((info) => {
              let align = 'justify'
              if (info.formatType === 2) {
                align = 'center'
              } else if (info.formatType === 3) {
                align = 'right'
              }
              return {
                ...info,
                align
              }
            })
            this.relatedReadInfo.info = infos


            this.imgView = this.relatedReadInfo.filePath
            this.relatedVisible = !this.imgView
            // this.previewFile = {
            //   name: this.relatedReadInfo.fileList[0].name || '',
            //   url: this.$resBasePath + this.relatedReadInfo.fileList[0].path || ''
            // }
            if (this.relatedReadInfo && this.relatedReadInfo.fileList && this.relatedReadInfo.fileList.length > 0) {
              const firstFile = this.relatedReadInfo.fileList[0];
              this.previewFile = {
                name: firstFile.name || '',
                url: this.$resBasePath + (firstFile.path || '')
              };
            } else {
              // 如果fileList为空或不存在，您可以设置previewFile为一个空对象或其他默认值
              //this.previewFile = {};
              // 或者，如果您想保持previewFile的当前结构并为其属性提供空字符串，可以这样做：
               this.previewFile = { name: '', url: '' };
            }
            console.log(this.previewFile)
            console.log(this.imgView)
            console.log(this.relatedVisible)
          })
    },
    base64Encode(url) {
      // 后台转换接口会根据文件链接来判断文件类型，如果不含类型，则需要手动指明fullfilename
      if (!this.fileType && url.includes('easemob.com')) {
        url += (url.includes('?') ? '&' : '?') + 'fullfilename=' + encodeURIComponent(this.file.name);
      }
      console.log(url);
      const encoder = new TextEncoder();
      const uint8Array = encoder.encode(url);
      const base64String = btoa(String.fromCharCode.apply(null, uint8Array));

      // return url;
      //return window.btoa(url);
      return base64String;
    },
    onload() {
      this.loading = false;
    },
  }
}
</script>

<style scoped lang="less">
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.main {
  width: 100%;
  padding-right: 40px;
  margin: 0px 20px;
}

.mainer {
  width: 100%;
  min-height: 200px;
  margin-top: 20px;
  margin-right: 40px;
  background: #fff;
  padding: 20px 30px 20px 30px;
  border-radius: 12px;
  height: calc(100vh - 185px);
  // max-height: 600px;
  overflow-y: auto;

  .title {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
  }

  .type-ul {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    display: flex;
    margin: 15px 0 15px 0;

    li {
      width: 100px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 2px;
      border: 1px solid @primary-color;
      color: @primary-color;
      margin-left: 12px;
      cursor: pointer;

      &:first-child {
        margin-left: 0px;
      }
    }

    .li {
      color: #fff;
      background: @primary-color;
    }
  }

  .s-mess {
    margin-top: 15px;

    .t-t {
      margin: 15px 0 15px 0;
    }

    .s-content {
      background: #f1f0f0;
      border-radius: 10px;
      padding: 15px;
      margin-top: 15px;
      cursor: pointer;

      .c-title {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333;
        line-height: 30px;
        display: flex;

        .t-l {
          width: calc(100% - 180px);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .t-r {
          width: 180px;
          font-size: 16px;
          font-family: PingFangSC-Regula r, PingFang SC;
          font-weight: 400;
          color: @primary-color;
          line-height: 24px;
          text-align: right;

          .person {
            text-align: right;
            width: 14px;
            height: 14px;
            margin: -4px 8px 0 0;
          }

          .name {
            margin-right: 15px;
          }
        }
      }

      .c-content {
        height: 40px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      &:first-child {
        margin-top: 0px;
      }
    }
  }
}

.model-content {
  .top {
    display: flex;

    .person {
      width: 12px;
      height: 12px;
      margin: 5px 10px 0 0;
    }

    .name {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: @primary-color;
      line-height: 24px;
    }
  }
}

/deep/ .ant-modal-body {
  padding: 10px 24px;
}

.relatedReadInfo-content {
  padding: 20px 40px;
  font-size: 18px;
  position: relative;

  .prev {
    font-size: 16px;
    color: @primary-color;
    position: absolute;
    cursor: pointer;
    right: 100px;
    top: 5px;
  }

  .next {
    font-size: 16px;
    color: @primary-color;
    position: absolute;
    cursor: pointer;
    right: 40px;
    top: 5px;
  }

  .relatedReadInfo-title {
    margin-right: 20px;
    font-size: 24px;
    text-align: center;
  }

  .relatedReadInfo-author {
    text-align: center;
    font-size: 16px;
    color: #cccccc;
  }
}

/deep/.ant-modal-body {
  max-height: calc(80vh - 10px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  &::-webkit-scrollbar-thumb {
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #e3e3e6;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
  }
}

.videoContent{
  display: table;
}
/deep/ .thumbnail{
  display: inline;
  align-items: center;
  margin: 2px 0;
}

</style>
